export { default } from './Accordion.jsx';
